import actionTypes from '../actions/actionTypes';

export const INITIAL_STATE = {
  loading: false,
  error: false,
  reservationsAmount: 0, //widget
};

export const reservationsWidgetReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.RESERVATIONS_AMOUNT_LOADING:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.RESERVATIONS_AMOUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        reservationsAmount: payload,
      };
    case actionTypes.RESERVATIONS_AMOUNT_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
      };

    default:
      return state;
  }
};

export default reservationsWidgetReducer;
